// @ts-ignore
import store from '@polleverywhere/redux'
// @ts-ignore
import { toCamelCase } from './toCamelCase'
import { Activity, slice as activePresenterSlice } from '../redux/responsePage'
import { ActivityModel } from './fetchActivity'

const SYNC_PROPS = {
  // ReduxKey: BackboneKey
  title: 'title',
  type: 'type',
  participantKey: 'participant_key',
  registeredParticipantsOnly: 'registered_participants_only',
  gradingEnabled: 'grading_enabled',
  anonymous: 'anonymous',
  inCompetition: 'competition_id',
  showBranding: 'show_branding',
  titleHidden: 'title_hidden',
  polls: 'polls'
}
const CHANGE_EVENTS = Object.values(SYNC_PROPS).map(prop => `change:${prop}`).join(' ')

function activityModelToRedux (model: ActivityModel) {
  return Object.entries(SYNC_PROPS)
    .reduce((activity, [ reduxKey, bbKey ]) => {
      if (reduxKey === 'inCompetition') {
        activity[reduxKey] = !!model.get(bbKey)
      } else if (reduxKey === 'type') {
        activity[reduxKey] = model.type?.() || model.get(bbKey)
      } else {
        activity[reduxKey] = model.get(bbKey)
      }
      return activity
    }, {} as Activity)
}

function stopLiveUpdate (model: ActivityModel) {
  if (model.type() === 'discourse') {
    model.stopLiveUpdate()
  } else if (model.type() === 'survey' && model.polls) {
    model.instance.stop()
    model.polls.each((poll) => poll.instance.stop())
  } else if (model.instance) {
    model.instance.stop()
  }
}

function startLiveUpdate (model: ActivityModel) {
  if (model.type() === 'discourse') {
    model.liveUpdate()
  } else if (model.type() === 'survey' && model.polls) {
    model.instance.start()
    model.polls.each((poll) => poll.instance.start())
  } else {
    model.instance.start()
  }
}

class ActivitySync {
  private currentModel: ActivityModel | undefined
  private pinnedModel: ActivityModel | undefined
  private syncCurrent: () => void
  private syncPinned: () => void

  constructor () {
    this.syncCurrent = () => {
      const activity = this.currentModel ? activityModelToRedux(this.currentModel) : undefined
      store.dispatch(activePresenterSlice.setCurrentActivity(activity))
    }
    this.syncPinned = () => {
      const activity = this.pinnedModel ? activityModelToRedux(this.pinnedModel) : undefined
      store.dispatch(activePresenterSlice.setPinnedActivity(activity))
    }
  }

  getCurrent () {
    return this.currentModel
  }

  getPinned() {
    return this.pinnedModel
  }

  async setCurrent (model: ActivityModel) {
    if (this.currentModel) this.clearCurrent()

    this.currentModel = model
    this.currentModel.on(CHANGE_EVENTS, this.syncCurrent)
    this.syncCurrent()
    startLiveUpdate(this.currentModel)
    return this.currentModel
  }

  async setPinned (model: ActivityModel) {
    if (this.pinnedModel) this.clearPinned()

    this.pinnedModel = model
    this.pinnedModel.on(CHANGE_EVENTS, this.syncPinned)
    this.syncPinned()
    startLiveUpdate(this.pinnedModel)
    return this.pinnedModel
  }

  clearCurrent () {
    if (this.currentModel) {
      this.currentModel.off?.('change', this.syncCurrent)
      stopLiveUpdate(this.currentModel)
      delete this.currentModel
      this.syncCurrent()
    }
  }

  clearPinned () {
    if (this.pinnedModel) {
      this.pinnedModel.off?.('change', this.syncPinned)
      stopLiveUpdate(this.pinnedModel)
      delete this.pinnedModel
      this.syncPinned()
    }
  }
}

const activitySync = new ActivitySync()
export default activitySync
